// PAWPRO — Global reveal-on-scroll via Intersection Observer
// Activates [data-pawpro-reveal] elements when they enter the viewport.
// Respects prefers-reduced-motion.

(function() {
  'use strict';

  function initReveal() {
    const reveals = document.querySelectorAll('[data-pawpro-reveal]:not(.is-revealed)');
    if (!reveals.length) return;

    // If user prefers reduced motion, reveal immediately
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach(el => el.classList.add('is-revealed'));
      return;
    }

    // No IntersectionObserver support? Reveal immediately
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(el => el.classList.add('is-revealed'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -8% 0px'
    });

    reveals.forEach(el => observer.observe(el));
  }

  // Init on DOM ready + watch for dynamic content (Shopify section reload)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-init when Shopify section editor reloads a section
  document.addEventListener('shopify:section:load', initReveal);
})();
